// extracted by mini-css-extract-plugin
export default {"root":"Organizer_root__p1Gl9","name":"Organizer_name__Ji6Z0"};